module.exports = __webpack_public_path__ + "img/pay.0e851eca.png";